import React, { useContext, useEffect, useRef } from 'react';
import Product from '../products/Product';
import SearchContext from '../../context/searchContext';
import InfiniteScroll from 'react-infinite-scroll-component';
import IconLoading from '../shared/IconLoading';
import LoadingBar from '../shared/EclipseLoading';
import './Search.css';
import { Route, Routes, useLocation } from 'react-router-dom';
import ProductDetails from '../products/ProductDetails';
import { getPosition } from '../../util/ScrollRestoration';


const Search = () => {

    const searchContext = useContext(SearchContext)
    const elementRef = useRef(null);
    const executeScroll = () => window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    const { pathname } = useLocation();

    useEffect(() => {
        if (searchContext.products && searchContext.products.length && searchContext.products.length <= searchContext.perPage) {
            executeScroll();
        }
    }, [searchContext.products, searchContext.perPage])

    useEffect(() => {
        if (pathname === '/search') {
            getPosition('/search');
        }
    }, [pathname])

    return (
        <div className='all-product-layer' >
            <Routes>
                <Route path="/:id" element={<ProductDetails />} />
            </Routes>
            {
                pathname === "/search" &&
                <React.Fragment>
                    <header className='w-100 search-result'>
                        {
                            searchContext.searchInput ?
                                <h6>
                                    <span></span>
                                    نتایج جستجو <small className='me-3 ms-2'>:</small>{searchContext.searchInput}
                                </h6>
                                :
                                <h6>
                                    <span></span>
                                    جستجو کنید
                                </h6>
                        }
                    </header>
                    <section ref={elementRef}></section>
                    {searchContext.products && searchContext.products.length ?
                        <InfiniteScroll
                            dataLength={searchContext.products && searchContext.products.length}
                            next={searchContext.fetchMoreData}
                            hasMore={searchContext.hasMore}
                            loader={
                                <div className="d-flex flex-column text-center mt-2 mb-5 mb-sm-2 w-100">
                                    <span className="mx-auto">
                                        {
                                            searchContext.products.length ?
                                                <IconLoading
                                                    type="spin"
                                                    color={"#777"}
                                                    width={50}
                                                    height={50}
                                                /> : null
                                        }
                                    </span>
                                </div>
                            }
                            endMessage={''}
                        >
                            {
                                searchContext.products.map((product, index) =>
                                    <Product
                                        key={product._id}
                                        _id={product._id}
                                        code={product.code}
                                        name={product.name}
                                        price={product.price}
                                        fakePrice={product.fakePrice}
                                        inventory={product.inventory}
                                        image={product.image}
                                        info={product.info}
                                        incrementalStep={product.incrementalStep}
                                        unit={product.unit}
                                        comeFrom={'search'}
                                    />
                                )
                            }
                        </InfiniteScroll>
                        :
                        <section style={{
                            height: '60vh',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center'
                        }}>
                            {
                                searchContext.products && !searchContext.products.length ?
                                    <p className='text-secondary'>موردی برای نمایش وجود ندارد</p> :
                                    searchContext.isSearching ?
                                        <LoadingBar classNames={`ldio-text-danger`} /> :
                                        <p className='text-secondary'>نتایج جستجو</p>
                            }
                        </section>
                    }
                </React.Fragment>
            }
        </div>
    );
}

export default Search;